import Flickity from 'flickity';
import { lenis } from '../global/gsap';

const initLightbox = (element, toggles) => {
    const lightboxClose = element.querySelector('.js-lightbox-close');
    const carouselEl = element.querySelector('.js-lightbox-carousel');
    const prev = element.querySelector('.js-carousel-prev');
    const next = element.querySelector('.js-carousel-next');

    const isWrapped = true;
    let isInstant = false;
    let draggable = true;

    if (localStorage.carbonSave === 'on') {
        isInstant = true;
        draggable = false;
    }

    const flickityOptions = {
        cellAlign: 'left',
        wrapAround: true,
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        draggable
    };

    window.lightboxCarousel = null;
    window.lightboxActive = false;

    if (window.lightboxCarousel) {
        window.lightboxCarousel.destroy();
    }

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const activeSlide = parseFloat(toggle.dataset.lightboxToggle) - 1;

            if (!window.lightboxActive) {
                window.lightboxActive = true;
                element.classList.add('show');
                window.lightboxCarousel = new Flickity(carouselEl, flickityOptions);
                window.lightboxCarousel.select(activeSlide, false, true);
                lenis.stop();
            }
        });
    });

    lightboxClose.addEventListener('click', () => {
        if (window.lightboxActive) {
            window.lightboxActive = false;
            element.classList.remove('show');
            window.lightboxCarousel.destroy();
            lenis.start();
        }
    });

    if (prev) {
        prev.addEventListener('click', () => {
            window.lightboxCarousel.previous(isWrapped, isInstant);
        });
    }

    if (next) {
        next.addEventListener('click', () => {
            window.lightboxCarousel.next(isWrapped, isInstant);
        });
    }
};

export { initLightbox as default };
